import { render, staticRenderFns } from "./BillsInfoModal.vue?vue&type=template&id=85fe7ffe&scoped=true&"
import script from "./BillsInfoModal.vue?vue&type=script&lang=js&"
export * from "./BillsInfoModal.vue?vue&type=script&lang=js&"
import style0 from "./BillsInfoModal.vue?vue&type=style&index=0&id=85fe7ffe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85fe7ffe",
  null
  
)

export default component.exports